@if (form && control) {
  <div [formGroup]="form">
    <app-material-input-datepicker
      [require]="require"
      [formControlName]="field_name">
      <ng-content></ng-content>
    </app-material-input-datepicker>
  </div>
}
